module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "modal-card",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_vm._m(0), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('p', [_vm._v("Digite abaixo uma nova senha para a sua conta. Após salvar você poderá autenticar normalmente com sua nova senha.")]), _c('hr'), _c('b-field', {
    attrs: {
      "label": "Senha*",
      "message": _vm.errors.first('senha'),
      "type": _vm.isDanger('senha')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validations.password),
      expression: "validations.password"
    }],
    ref: "senha",
    attrs: {
      "type": "password",
      "placeholder": "Digite sua nova senha",
      "name": "senha",
      "password-reveal": "password-reveal"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _c('b-field', {
    attrs: {
      "label": "Confirmar Senha*",
      "message": _vm.errors.first('confirm'),
      "type": _vm.isDanger('confirm')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validations.confirm),
      expression: "validations.confirm"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Repita sua nova senha",
      "name": "confirm",
      "data-vv-as": "confirmação de senha",
      "password-reveal": "password-reveal"
    },
    model: {
      value: (_vm.user.confirm),
      callback: function($$v) {
        _vm.$set(_vm.user, "confirm", $$v)
      },
      expression: "user.confirm"
    }
  })], 1), _c('b-field', {
    staticClass: "has-text-centered"
  })], 1), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.formInvalid,
      "type": "submit"
    }
  }, [_vm._v("Salvar")]), _c('a', {
    staticClass: "button is-danger is-outlined",
    on: {
      "click": function($event) {
        return _vm.$parent.close()
      }
    }
  }, [_vm._v("Fechar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Redefinir Senha")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c35dca02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/components/ResetPasswordModal.vue
// module id = 410
// module chunks = 56